
import "./TypingIndicator.scss"; 
 
const SIZE_MAP = {
  sm: 6,
  md: 8,
};
 
export default function TypingIndicator({ size = "md" }) {
  const px = SIZE_MAP[size] ?? SIZE_MAP.md;
  return (
<div className="flex items-center gap-1">
<span className="ti-dot ti-dot1 inline-block rounded-full" style={{ width: px, height: px }} />
<span className="ti-dot ti-dot2 inline-block rounded-full" style={{ width: px, height: px }} />
<span className="ti-dot ti-dot3 inline-block rounded-full" style={{ width: px, height: px }} />
</div>
  );
}